module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('h2', {
    staticClass: "h2fm"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_vm._v("My gratitude is due, above all, to Madame Lucien Peyraud—Lulu—who, for well over a year, willingly sacrificed weekly afternoons to visit me and to chat about the food that she has cooked for family and friends and the life that she has led with them for fifty years and more, to Lucien Peyraud, the impassioned and adorable patriarch of Bandol wine, and to all the Peyraud family, most especially Jean-Marie and his wife, Catherine, François and his wife, Paule, and Laurence Peyraud. Fleurine, Marion, Colette, and Véronique have all contributed, as well as numerous grand-children, Zavier, Jérome, Valérie, and Florence, among others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alice Waters, whose enthusiasms tolerate no checks and whose love for the Peyraud family, of Lulu’s table, and the wines of Domaine Tempier knows no bounds, deserves credit for having insisted that I write the book and for having placed me in the hands of her agent, Susan Lescher. Kermit Lynch, who imports something more than a third of Domaine Tempier’s production into the United States and who, with his wife, Gail Skoff, and their children, spends half the year amid the vines of Bandol, joined his enthusiasm to Alice’s to create a formidable barrage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am grateful to Gail Skoff, with whom I worked closely in the choice of subjects and of final photographs, for her suppleness and for the lovely clarity of her work, and to Patricia Curtan for the beauty of the book design.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, I owe a great thank-you to my editor, Susan Friedland, for putting up with my unorthodox, pre-computer-age methods of writing and for her admirable restraint in the use of the “blue pencil”.")]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p3-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "ack"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 63
// module chunks = 0